export const DEFAULT_BRAND = "#059669";
const MIX = { 50: 0.94, 100: 0.86, 200: 0.72, 300: 0.52, 400: 0.28, 500: 0.1, 600: 0, 700: -0.18, 800: -0.34, 900: -0.48, 950: -0.66 };
let current = DEFAULT_BRAND;

const toRgb = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));

export function shades(hex) {
  const rgb = toRgb(hex);
  return Object.fromEntries(Object.entries(MIX).map(([k, m]) => [k, rgb.map((c) => Math.round(m >= 0 ? c + (255 - c) * m : c * (1 + m)))]));
}

export function contrastWithWhite(hex) {
  const lum = toRgb(hex).map((c) => { const s = c / 255; return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4; });
  const L = 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
  return 1.05 / (L + 0.05);
}

export function applyBrandColor(hex) {
  current = /^#[0-9a-fA-F]{6}$/.test(hex || "") ? hex : DEFAULT_BRAND;
  const root = document.documentElement.style;
  Object.entries(shades(current)).forEach(([k, rgb]) => root.setProperty(`--brand-${k}`, rgb.join(" ")));
}

export const brandHex = () => current;
